import { IconButton } from '@mui/material';
import styled from 'styled-components';

const ADIButton = () => {
    return (
        <ChatTrigger>
            <Image src="/assets/adi/adi-cuerpo.png" alt="ADI" />
        </ChatTrigger>
    );
};

export default ADIButton;

const ChatTrigger = styled(IconButton)`
    &&.MuiIconButton-root {
        background-color: #b31d15;
        color: white;
        width: 50px;
        height: 50px;
        z-index: 10;
        border-radius: 50%;
        overflow: visible;
        svg {
            font-size: 28px;
        }
        &:hover img {
            transform: scale(1.3);
        }
    }
`;

const Image = styled.img`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    transition: transform 0.2s ease-in-out;
`;
